import React, { memo } from 'react';
import styles from './DataTableFilterDrawerHeader.module.scss';
import SearchIcon from '../../../../../../assets/Svg/SearchIcon';

interface DataTableFilterDrawerHeaderProps {
    title?: string;
    searchQuery?: string;
    onSearchChange?: (value: string) => void;
    searchPlaceholder?: string;
}

const DataTableFilterDrawerHeader: React.FC<DataTableFilterDrawerHeaderProps> = ({
    title = 'Filters',
    searchQuery,
    onSearchChange,
    searchPlaceholder = 'Search Filter',
}) => {
    const showSearch = typeof onSearchChange === 'function';

    return (
        <div className={styles.Header}>
            <h2 className={styles.Title}>{title}</h2>
            {showSearch && (
                <div className={styles.SearchWrapper}>
                    <input
                        type="text"
                        className={styles.SearchInput}
                        value={searchQuery ?? ''}
                        onChange={(e) => onSearchChange?.(e.target.value)}
                        placeholder={searchPlaceholder}
                        aria-label={searchPlaceholder}
                        spellCheck={false}
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                    />
                    <SearchIcon className={styles.SearchIcon} />
                </div>
            )}
        </div>
    );
};

export default memo(DataTableFilterDrawerHeader);
